export const QUESTION_INSIGHTS_ENABLED_COOKIE = 'questionInsightsEnabled'

export const PREP_QUESTIONS_TITLE = 'Questions to expect'
export const PREP_QUESTIONS_SUBTITLE = 'Based on all meetings, last 7 days'

export const LIKELY_QUESTIONS_WINDOW = '7d'

export const LIKELY_QUESTIONS_LIMIT = 10

export const COLLAPSED_QUESTION_COUNT = 4
